import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./CreateBranchForm.css";
import Modal from "react-bootstrap/Modal";
import MapWrapper from "../../../../Components/UiComponents/MapWrapper/MapWrapper";
import {
  createBranch,
  findRegionsByUser,
  getThemeURL,
  getJobTitle,
  updateBranchDetails,
  getallBanksByRole,
} from "../../../../Services/EndPoints";
//  API services
import {
  postDataWithBody,
  getData,
  putDataWithBody,
} from "../../../../Services/Services";
// import LocationAutoComplete from "./LocationAutoComplete"; // Adjust the path as needed
import { XCircleblack } from "../../../../Components/IconComponents";
import MapWrapperForEdit from "../../IncidentManagement/AddIncidentForm/MapWarapperForEdit";

// Component for displaying create/edit branch details form
const CreateBranchForm = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const location = useLocation();
  const { isTextFieldDisable } = location.state || {};
  let data = state?.data;
  let dataForEdit = state?.dataForEdit;
  let branchData = state?.branchData;
  let mapview = state?.edit;
  const [loader, setLoader] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [contactEntries, setContactEntries] = useState([
    {
      firstName: "",
      lastName: "",
      phoneNumber: "",
      email: "",
      jobTitleId: "",
      seq: 1,
    },
  ]);
  const [banksList, setBanksList] = useState([]); // State for banks list
  const [districtList, setDistrictList] = useState([]); // State for banks list
  const [userId, setUserId] = useState(null);
  const [jobTitleList, setJobTitleList] = useState([]); // State for banks list
  const [showCancelModal, setShowCancelModal] = useState(false);
  // Map related states
  const [showMapModal, setShowMapModal] = useState(false);
  const [coordinates, setCoordinates] = useState([
    {
      y: 85.562, // default longitude
      x: 25.747, // default latitude
    },
  ]);
  const [zoomLevel, setZoomLevel] = useState(8);
  const [mapKey, setMapKey] = useState(0);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [existingImageData, setExistingImageData] = useState(null);
  const [imageToRemove, setImageToRemove] = useState(false);
  const [fontStyles, setFontStyles] = useState({
    branchNameFontSize: "18",
    branchNameColor: "#000000",
  });

  // Validation errors state
  const [validationErrors, setValidationErrors] = useState({
    branchName: "",
    district: "",
    ifscCode: "",
    entryDate: "",
    addressLine1: "",
    pinCode: "",
    city: "",
    mandal: "",
    brphoneNumber: "",
    bremail: "",
    dscbname: "",
    firstName: "",
    lastName: "",
    contactPhoneNumber: "",
    contactEmailAddress: "",
  });

  // Helper function to convert byte array to base64
  const byteArrayToBase64 = (byteArray) => {
    if (!byteArray || !Array.isArray(byteArray) || byteArray.length === 0) {
      console.log("Invalid byte array:", byteArray);
      return null;
    }

    try {
      // Convert array to Uint8Array if needed
      const uint8Array =
        byteArray instanceof Uint8Array ? byteArray : new Uint8Array(byteArray);

      // Convert to binary string
      let binary = "";
      const chunkSize = 8192; // Process in chunks to avoid call stack issues

      for (let i = 0; i < uint8Array.length; i += chunkSize) {
        const chunk = uint8Array.slice(i, i + chunkSize);
        binary += String.fromCharCode.apply(null, chunk);
      }

      // Convert to base64
      const base64 = btoa(binary);

      // Return with proper data URL prefix
      return "data:image/png;base64," + base64;
    } catch (error) {
      console.error("Error converting byte array to base64:", error);
      return null;
    }
  };

  // Helper function to convert timestamp to "yyyy-mm-dd" format (for date input)
const timestampToDateInputFormat = (timestamp) => {
  if (!timestamp) return new Date().toISOString().split('T')[0];
  
  try {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      return new Date().toISOString().split('T')[0];
    }
    
    // Format as yyyy-mm-dd for date input
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error('Error converting timestamp:', error);
    return new Date().toISOString().split('T')[0];
  }
};

// Helper function to convert timestamp to display format (dd-mm-yyyy)
const timestampToDisplayFormat = (timestamp) => {
  if (!timestamp) {
    const today = new Date();
    return today.toLocaleDateString('en-IN');
  }
  
  try {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      return new Date().toLocaleDateString('en-IN');
    }
    
    return date.toLocaleDateString('en-IN');
  } catch (error) {
    console.error('Error converting timestamp to display format:', error);
    return new Date().toLocaleDateString('en-IN');
  }
};

  //useEffect for selected bank font color and font size
  useEffect(() => {
    if (dataForEdit && banksList.length > 0) {
      const { branchData } = location.state || {};
      const selectedBank = banksList.find(
        (bank) =>
          bank.id.toString() === dataForEdit.bankId ||
          bank.bankName === dataForEdit.bankName
      );

      if (branchData) {
        setFontStyles({
          branchNameFontSize: branchData.branchNameFontsize
            ? branchData.branchNameFontsize.replace("px", "")
            : "18",
          branchNameColor: branchData.branchNameColour || "#000000",
        });
      } else {
        // Default values for new branch
        setFontStyles({
          branchNameFontSize: "18",
          branchNameColor: "#000000",
        });
      }

      // Get district - prioritize branch data if available, then bank data
      const districtValue =
        branchData?.district ||
        dataForEdit.district ||
        selectedBank?.district ||
        "";

      if (branchData) {
        // EDIT MODE
        setFormData({
          branchName: branchData.branchName || "",
          dscbname: selectedBank?.id?.toString() || "",
          bankId: dataForEdit.bankId || null,
          ifscCode: branchData.ifscCode || "",
          activeStatus: branchData.activeStatus || false,
          entryDate: timestampToDateInputFormat(branchData.entryDate), 
          addressLine1: branchData.addressLine1 || "",
          addressLine2: branchData.addressLine2 || "",
          pinCode: branchData.pinCode || "",
          city: branchData.city || "",
          mandal: branchData.mandal || "",
          state: branchData.state || "",
          district: districtValue, // Use the determined district value
          brphoneNumber: branchData.phoneNumber || "",
          bremail: branchData.email || "",
          latitude: branchData.latitude || "",
          longitude: branchData.longitude || "",
        });

        // Handle existing image data
        if (branchData?.image) {
          // If image is a byte array (from database)
          if (Array.isArray(branchData.image)) {
            const base64Image = byteArrayToBase64(branchData.image);
            if (base64Image) {
              setExistingImageData(branchData.image); // Store original byte array
              setLogoPreview(base64Image); // Set preview
            }
          }
          // If image is already base64 string with data URL prefix
          else if (
            typeof branchData.image === "string" &&
            branchData.image.startsWith("data:image/")
          ) {
            setLogoPreview(branchData.image);
            setExistingImageData(branchData.image);
          }
          // If image is base64 string WITHOUT data URL prefix (most likely case)
          else if (
            typeof branchData.image === "string" &&
            branchData.image.length > 0
          ) {
            // Add the data URL prefix to make it displayable
            const dataUrl = `data:image/png;base64,${branchData.image}`;
            setLogoPreview(dataUrl);
            setExistingImageData(branchData.image); // Store original base64 string
          }
        }

        // Set working days from the branch
        if (branchData.branch_work_time?.length > 0) {
          const updatedWorkingDays = { ...workingDays };
          // Reset all days first
          Object.keys(updatedWorkingDays).forEach((day) => {
            updatedWorkingDays[day] = {
              checked: false,
              fromTime: "",
              toTime: "",
            };
          });

          // Set only the days that have working hours
          branchData.branch_work_time.forEach((workTime) => {
            if (updatedWorkingDays[workTime.day]) {
              updatedWorkingDays[workTime.day] = {
                checked: true,
                fromTime: workTime.fromTime.slice(0, 5),
                toTime: workTime.toTime.slice(0, 5),
              };
            }
          });
          setWorkingDays(updatedWorkingDays);
        }

        // Set contact entries from the branch
        if (branchData.branch_contact?.length > 0) {
          const formattedContacts = branchData.branch_contact.map(
            (contact, index) => ({
              firstName: contact.firstName || "",
              lastName: contact.lastName || "",
              phoneNumber: contact.phoneNumber || "",
              email: contact.email || "",
              jobTitleId: contact.job_title_id?.toString() || "",
              seq: index + 1,
            })
          );
          setContactEntries(formattedContacts);
        }
      } else {
        // CREATE MODE
        setFormData({
          branchName: "",
          dscbname: selectedBank?.id?.toString() || "",
          bankId: dataForEdit.bankId || null,
          ifscCode: "",
          activeStatus: false,
          entryDate: new Date().toISOString().split("T")[0],
          addressLine1: "",
          addressLine2: "",
          pinCode: "",
          city: "",
          mandal: "",
          state: dataForEdit.state || "",
          district: districtValue, // Use the determined district value
          brphoneNumber: "",
          bremail: "",
          latitude: "",
          longitude: "",
        });
        // Reset working days and contacts for new branch
        setWorkingDays({
          Monday: { checked: false, fromTime: "", toTime: "" },
          Tuesday: { checked: false, fromTime: "", toTime: "" },
          Wednesday: { checked: false, fromTime: "", toTime: "" },
          Thursday: { checked: false, fromTime: "", toTime: "" },
          Friday: { checked: false, fromTime: "", toTime: "" },
          Saturday: { checked: false, fromTime: "", toTime: "" },
          Sunday: { checked: false, fromTime: "", toTime: "" },
        });
        setContactEntries([
          {
            firstName: "",
            lastName: "",
            phoneNumber: "",
            email: "",
            jobTitleId: "",
            seq: 1,
          },
        ]);
      }
    }
  }, [dataForEdit, banksList, location.state]);

  // Add validation functions for phone number and email in contacts
  const validateContactPhoneNumber = (value) => {
    // If empty, it's not required anymore
    if (!value || !value.trim()) {
      return "";
    }

    // Check if it's a 10-digit mobile number
    if (/^[6-9]\d{9}$/.test(value)) {
      return "";
    }

    // Check if it's a landline number
    if (/^[0]\d{1,3}[-\s]?\d{6,8}$/.test(value)) {
      return "";
    }

    return "Enter a valid 10-digit mobile number or landline number (STD code + number)";
  };

  // First, add the validation function for contact email
  const validateContactEmailAddress = (value) => {
    // If empty, it's not required anymore
    if (!value || !value.trim()) {
      return "";
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return "Enter a valid email address (e.g., user@example.com)";
    }
    return "";
  };

  const validateLatitude = (value) => {
    // Handle undefined, null, or non-string values
    if (value === undefined || value === null) {
      return "";
    }

    // Convert to string if it's a number
    const strValue = String(value);

    // If empty string, it's optional so return no error
    if (!strValue || strValue.trim() === "") {
      return "";
    }

    // Check if it only contains numbers and decimal point
    if (!/^-?\d*\.?\d*$/.test(strValue)) {
      return "Latitude must contain only numbers and decimal point";
    }

    // Check if it has more than 14 decimal places
    const decimalPart = strValue.toString().split(".");
    if (decimalPart.length > 1 && decimalPart[1].length > 16) {
      return "Latitude can have maximum 16 digits after decimal point";
    }

    // Check if it's a valid latitude value (between -90 and 90)
    const latValue = parseFloat(strValue);
    if (isNaN(latValue) || latValue < -90 || latValue > 90) {
      return "Latitude must be a valid number between -90 and 90";
    }

    return "";
  };

  // Validate longitude
  const validateLongitude = (value) => {
    // Handle undefined, null, or non-string values
    if (value === undefined || value === null) {
      return "";
    }

    // Convert to string if it's a number
    const strValue = String(value);

    // If empty string, it's optional so return no error
    if (!strValue || strValue.trim() === "") {
      return "";
    }

    // Check if it only contains numbers and decimal point
    if (!/^-?\d*\.?\d*$/.test(strValue)) {
      return "Longitude must contain only numbers and decimal point";
    }

    // Check if it has more than 14 decimal places
    const decimalPart = strValue.toString().split(".");
    if (decimalPart.length > 1 && decimalPart[1].length > 16) {
      return "Longitude can have maximum 16 digits after decimal point";
    }

    // Check if it's a valid longitude value (between -180 and 180)
    const lngValue = parseFloat(strValue);
    if (isNaN(lngValue) || lngValue < -180 || lngValue > 180) {
      return "Longitude must be a valid number between -180 and 180";
    }

    return "";
  };

  // Function to validate working hours
  const validateWorkingHours = () => {
    let errorMessage = "";
    let hasCheckedDay = false;

    // Check if at least one day is selected
    Object.values(workingDays).forEach((day) => {
      if (day.checked) hasCheckedDay = true;
    });

    if (!hasCheckedDay) {
      return "Please select at least one working day";
    }

    // Validate each checked day
    for (const [day, details] of Object.entries(workingDays)) {
      if (!details.checked) continue;

      const fromTime = new Date(`2000-01-01T${details.fromTime}`);
      const toTime = new Date(`2000-01-01T${details.toTime}`);

      // Check if times are valid dates
      if (isNaN(fromTime) || isNaN(toTime)) {
        // errorMessage = `${day}: Please enter the valid working times`;
        errorMessage = `Please enter the valid working times`;
        break;
      }

      // Check if "to" time is after "from" time
      if (toTime <= fromTime) {
        errorMessage = "End time must be after start time";
        break;
      }

      // Calculate the time difference in hours
      const timeDiff = (toTime - fromTime) / (1000 * 60 * 60);

      // Check if working hours exceed 12 hours
      if (timeDiff > 12) {
        errorMessage = `${day}: Working hours cannot exceed 12 hours`;
        break;
      }
    }

    return errorMessage;
  };

  // Validate branch name
  const validateBranchName = (value) => {
    if (!value || !value.trim()) {
      return "Branch Name is required";
    }
    if (value.trim().length < 3) {
      return "Branch Name must be at least 3 characters";
    }
    if (value.trim().length > 50) {
      return "Branch Name must be less than 50 characters";
    }
    if (!/^[a-zA-Z0-9 ]+$/.test(value)) {
      return "Branch Name can only contain letters, numbers, and spaces";
    }
    return "";
  };

  // Validate district
  const validateDistrict = (value) => {
    if (!value || !value.trim()) {
      return "District is required";
    }
    return "";
  };
  // Validate district
  const validateDSCB = (value) => {
    if (!value || value === "") {
      return "Bank Name is required";
    }
    return "";
  };

  // Validate IFSC code
  const validateIFSCCode = (value) => {
    if (!value || !value.trim()) {
      return "IFSC Code is required";
    }
    if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)) {
      return "IFSC Code must follow the format: 4 letters, 0, and 6 alphanumeric characters";
    }
    return "";
  };

  // Validate address
  const validateAddress = (value, fieldName, isRequired = true) => {
    // If field is not required and empty, return no error
    if (!isRequired && (!value || !value.trim())) {
      return "";
    }

    // Required field validation
    if (isRequired && (!value || !value.trim())) {
      return `${fieldName} is required`;
    }

    // Length validation for non-empty values
    if (value && value.trim().length < 5) {
      return `${fieldName} must be at least 5 characters`;
    }
    if (value && value.trim().length > 100) {
      return `${fieldName} must be less than 100 characters`;
    }

    // Character validation
    if (value && !/^[a-zA-Z0-9 ,\-/.]+$/.test(value)) {
      return `${fieldName} can only contain letters, numbers, commas, hyphens, slashes, dots, and spaces`;
    }

    return "";
  };

  // Validate Pincode
  const validatePinCode = (value) => {
    if (!value || !value.trim()) {
      return "Pincode is required";
    }
    if (!/^[1-9][0-9]{5}$/.test(value)) {
      return "Pincode must be 6 digits and start with a non-zero digit";
    }
    return "";
  };

  // Validate City and Mandal
  const validateCityOrMandal = (value, fieldName) => {
    if (!value || !value.trim()) {
      return `${fieldName} is required`;
    }
    if (!/^[a-zA-Z\s]+$/.test(value)) {
      return `${fieldName} must contain letters and spaces only`;
    }
    if (value.trim().length > 50) {
      return `${fieldName} must be less than 50 characters`;
    }
    return "";
  };

  // Validate Phone/Landline
  const validateBrphoneNumber = (value) => {
    // If empty, it's not required anymore
    if (!value || !value.trim()) {
      return "Mobile/Landline Number is required";
    }

    // Check if it's a 10-digit mobile number
    if (/^[6-9]\d{9}$/.test(value)) {
      return "";
    }

    // Check if it's a landline number
    if (/^[0]\d{1,3}[-\s]?\d{6,8}$/.test(value)) {
      return "";
    }

    return "Enter a valid 10-digit mobile number or landline number (STD code + number)";
  };

  // Replace the validatefirstName function (lowercase f) with this consistent function
  const validateFirstName = (value) => {
    if (!value || !value.trim()) {
      return "First Name is required";
    }
    if (value.trim().length < 3) {
      return "First Name must be at least 3 characters";
    }
    if (!/^[a-zA-Z\s]+$/.test(value)) {
      return "First Name must contain letters and spaces only";
    }
    if (value.trim().length > 50) {
      return "First Name must be less than 50 characters";
    }
    return "";
  };

  // Replace the validateLastName function (lowercase f) with this consistent function
  const validateLastName = (value) => {
    if (!value || !value.trim()) {
      return "";
    }
    if (value.trim().length < 3) {
      return "Last Name must be at least 3 characters";
    }
    if (!/^[a-zA-Z\s]+$/.test(value)) {
      return "Last Name must contain letters and spaces only";
    }
    if (value.trim().length > 50) {
      return "Last Name must be less than 50 characters";
    }
    return "";
  };

  // Validate Email
  const validateBranchEmail = (value) => {
    // If empty, it's not required anymore
    if (!value || !value.trim()) {
      return "Email Address is required";
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return "Enter a valid email address (e.g., user@example.com)";
    }
    return "";
  };

  // Validate date
  const validateDate = (value) => {
    if (!value) {
      return "Date is required";
    }

    const selectedDate = new Date(value);
    const currentDate = new Date();

    // Check if valid date
    if (isNaN(selectedDate.getTime())) {
      return "Please enter a valid date";
    }

    // Reset time components for accurate date comparison
    selectedDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    if (selectedDate > currentDate) {
      return "Date cannot be in the future";
    }
    return "";
  };

  // State for working days and times
  const [workingDays, setWorkingDays] = useState({
    Monday: { checked: false, fromTime: "", toTime: "" },
    Tuesday: { checked: false, fromTime: "", toTime: "" },
    Wednesday: { checked: false, fromTime: "", toTime: "" },
    Thursday: { checked: false, fromTime: "", toTime: "" },
    Friday: { checked: false, fromTime: "", toTime: "" },
    Saturday: { checked: false, fromTime: "", toTime: "" },
    Sunday: { checked: false, fromTime: "", toTime: "" },
  });

  // Form data state
  const [formData, setFormData] = useState({
    branchName: "",
    district: "",
    bankId: null, // Default value
    ifscCode: "",
    activeStatus: false,
    entryDate: "",
    addressLine1: "",
    addressLine2: "",
    pinCode: "",
    city: "",
    mandal: "",
    state: "",
    brphoneNumber: "",
    bremail: "",
    latitude: "",
    longitude: "",
  });

  // Get today's date for date field max attribute
  const today = new Date().toISOString().split("T")[0];

  // Function to choose coordinates from map
  const chooseCoordinates = (longitude, latitude) => {
    // Update form data
    setFormData({
      ...formData,
      longitude: longitude,
      latitude: latitude,
    });

    // Update coordinates for the map
    setCoordinates([
      {
        y: longitude,
        x: latitude,
      },
    ]);

    // // Set center coordinates for the map
    // setMapCenterCoordinates({
    //   y: longitude,
    //   x: latitude,
    // });

    // Optional: Reset map key to force re-render
    setMapKey((prevKey) => prevKey + 1);
  };

  // // Function to update map location from search
  // const updateMapLocation = (lat, lng) => {
  //   setCoordinates([{ y: lng, x: lat }]);
  //   setFormData({
  //     ...formData,
  //     latitude: lat,
  //     longitude: lng,
  //   });
  //   // setMapCenterCoordinates({
  //   //   y: lng,
  //   //   x: lat,
  //   // });
  //   setZoomLevel(16);
  //   setMapKey((prevKey) => prevKey + 1);
  // };

  // Function to open map modal
  const openMapModal = () => {
    setShowMapModal(true);
  };

  // Function to close map modal
  const closeMapModal = () => {
    setShowMapModal(false);
  };

  const selectedBank = banksList.find(
    (bank) => bank.id === parseInt(formData.dscbname)
  );
  // Fetch banks on component mount
  useEffect(() => {
    getUserProfile();
  }, []);
  // Fetch job title
  useEffect(() => {
    fetchJobtitle();
  }, []);

  // Fetch District list
  useEffect(() => {
    fetchDistrictList();
  }, []);

  useEffect(() => {
    fetchUserProfile();
  }, []);

  // Initialize form with data if available
  useEffect(() => {
    if (data) {
      const updatedData = { ...data };
      if (updatedData.phoneNumber) {
        updatedData.brphoneNumber = updatedData.phoneNumber;
        delete updatedData.phoneNumber;
      }

      setFormData({
        ...formData,
        ...data,
      });

      // Initialize working days if available
      if (data.branch_work_time && data.branch_work_time.length > 0) {
        const updatedWorkingDays = { ...workingDays };
        data.branch_work_time.forEach((workTime) => {
          if (updatedWorkingDays[workTime.day]) {
            updatedWorkingDays[workTime.day] = {
              checked: true,
              fromTime: workTime.fromTime.slice(0, 5),
              toTime: workTime.toTime.slice(0, 5),
            };
          }
        });
        setWorkingDays(updatedWorkingDays);
      }

      // Initialize contact entries if available
      if (data.branch_contact && data.branch_contact.length > 0) {
        setContactEntries(data.branch_contact);
      }
    }
  }, [data]);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { id, value, type, checked } = e.target;

    if (type === "checkbox" && id === "activeStatusCheck") {
      setFormData({ ...formData, activeStatus: checked });
    } else if (id === "dscbname") {
      // When a bank is selected from dropdown, update both the visual selection and bankId
      // const selectedBank = banksList.find(bank => bank.id === value);
      const selectedBank = banksList.find(
        (bank) => bank.id === parseInt(value)
      );
      setFormData({
        ...formData,
        dscbname: value,
        bankId: value, // Set bankId to the selected value
        // district: selectedBank?.district || "" // Optionally update district based on selected bank
      });
      // Clear the validation error immediately when a bank is selected
      setValidationErrors({
        ...validationErrors,
        dscbname: "", // Clear error when bank is selected
      });
    } else {
      setFormData({ ...formData, [id]: value });

      // Validation block
      let error = "";
      switch (id) {
        case "branchName":
          error = validateBranchName(value);
          break;
        case "district":
          error = validateDistrict(value);
          break;
        case "ifscCode":
          error = validateIFSCCode(value);
          break;
        case "entryDate":
          error = validateDate(value);
          break;
        case "latitude":
          error = validateLatitude(value);
          break;
        case "longitude":
          error = validateLongitude(value);
          break;
        case "addressLine1":
          error = validateAddress(value, "Address Line", true);
          break;
        case "pinCode":
          error = validatePinCode(value);
          break;
        case "city":
          error = validateCityOrMandal(value, "City");
          break;
        case "mandal":
          error = validateCityOrMandal(value, "Mandal");
          break;
        case "brphoneNumber":
          error = validateBrphoneNumber(value);
          break;
        case "bremail":
          error = validateBranchEmail(value);
          break;
        case "firstName":
          error = validateFirstName(value);
          break;
        case "lastName":
          error = validateLastName(value);
          break;
        case "contactPhoneNumber":
          error = validateContactPhoneNumber(value);
          break;
        case "dscbname":
          error = validateDSCB(value);
          break;
        default:
          break;
      }
      // Set validation error for the current field
      setValidationErrors({
        ...validationErrors,
        [id]: error,
      });
    }
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type (JPEG, PNG, SVG only)
      const validTypes = ["image/jpeg", "image/png", "image/svg+xml"];
      const validExtensions = [".jpg", ".jpeg", ".png", ".svg"];

      const fileExtension = file.name.split(".").pop().toLowerCase();
      const isValidType =
        validTypes.includes(file.type) ||
        validExtensions.includes(`.${fileExtension}`);

      if (!isValidType) {
        toast.error(
          "Please upload a valid image file (JPEG, PNG, or SVG only)"
        );
        e.target.value = ""; // Clear the invalid file
        return;
      }

      // Validate file size (max 2MB)
      if (file.size > 2 * 1024 * 1024) {
        toast.error("File size should be less than 2MB");
        e.target.value = ""; // Clear the oversized file
        return;
      }

      setLogoFile(file);
      setExistingImageData(null); // Clear existing image data when new file is selected
      setImageToRemove(false); // Reset remove flag

      // Create preview (except for SVG which can't be previewed directly)
      if (file.type !== "image/svg+xml") {
        const reader = new FileReader();
        reader.onloadend = () => {
          setLogoPreview(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        // For SVG files, we'll just store the file (preview not possible)
        setLogoPreview(null);
      }
    }
  };

  const handleLogoRemove = () => {
    setLogoFile(null);
    setLogoPreview(null);

    // Clear the file input value
    const fileInput = document.getElementById("branchLogo");
    if (fileInput) {
      fileInput.value = "";
    }

    // If we had existing image data, mark it for removal
    if (existingImageData) {
      setImageToRemove(true);
      setExistingImageData(null);
    }

    // Also clear any existing logo in formData if editing
    setFormData({
      ...formData,
      logoUrl: "",
    });
  };

  const getUserProfile = async () => {
    try {
      const userProfile = await getData(getThemeURL);
      if (userProfile && userProfile.length > 0) {
        fetchBanks(userProfile[0]);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const createPayload = (profile) => {
    let admin_role;

    if (profile.role_name === "SUPER ADMIN") {
      admin_role = "SA";
    } else if (profile.is_admin === true) {
      admin_role = "HO";
    } else {
      admin_role = "U";
    }

    return {
      admin_role: admin_role,
      bank_id: profile.bank_id || null,
      branch_id: profile.branch_id || null,
    };
  };

  // Fetch banks from API
  const fetchBanks = async (profile) => {
    setLoader(true);
    try {
      const payload = createPayload(profile);
      const response = await postDataWithBody(getallBanksByRole, payload, {});
      if (response && Array.isArray(response)) {
        setBanksList(response);
      } else {
        console.error("Invalid banks data format:", response);
        toast.error("Failed to load banks data");
      }
    } catch (error) {
      console.error("Error fetching banks:", error);
      toast.error("Failed to load banks data");
    } finally {
      setLoader(false);
    }
  };
  // Fetch job title from API
  const fetchJobtitle = async () => {
    setLoader(true);
    try {
      const response = await getData(getJobTitle);
      if (response && Array.isArray(response)) {
        setJobTitleList(response);
      } else {
        console.error("Unexpected job titles response format", response);
        toast.error("Failed to load job titles");
      }
    } catch (error) {
      console.error("Error fetching job titles:", error);
      toast.error("Failed to load job titles");
    } finally {
      setLoader(false);
    }
  };

  const fetchUserProfile = async () => {
    try {
      const response = await getData(getThemeURL);
      if (response && Array.isArray(response) && response.length > 0) {
        setUserId(response[0].id); // Get `id` from the first user
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  // Fetch banks from API
  const fetchDistrictList = async () => {
    setLoader(true);
    try {
      const response = await getData(findRegionsByUser);
      if (response && Array.isArray(response)) {
        setDistrictList(response);
      } else {
        console.error("Invalid banks data format:", response);
        toast.error("Failed to load banks data");
      }
    } catch (error) {
      console.error("Error fetching banks:", error);
      toast.error("Failed to load banks data");
    } finally {
      setLoader(false);
    }
  };

  // Handle working days changes
  const handleWorkingDayChange = (day, field, e) => {
    const value = field === "checked" ? e.target.checked : e.target.value;

    const updatedWorkingDays = { ...workingDays };

    if (field === "checked") {
      updatedWorkingDays[day].checked = value;
    } else if (field === "fromTime") {
      updatedWorkingDays[day].fromTime = value;

      // Optional: Auto-adjust "to" time if it's now less than "from" time
      const fromTime = new Date(`2000-01-01T${value}`);
      const toTime = new Date(`2000-01-01T${updatedWorkingDays[day].toTime}`);

      if (toTime <= fromTime) {
        // Add 1 hour to the from time to set a reasonable to time
        const newToTime = new Date(fromTime);
        newToTime.setHours(newToTime.getHours() + 1);
        updatedWorkingDays[day].toTime = newToTime.toTimeString().slice(0, 5);
      }
    } else if (field === "toTime") {
      updatedWorkingDays[day].toTime = value;
    }

    setWorkingDays(updatedWorkingDays);

    // You could optionally show real-time validation messages here
    const workingHoursError = validateWorkingHours();
    setValidationErrors((prev) => ({
      ...prev,
      workingHours: workingHoursError,
    }));
  };

  // In the handleContactChange function, add validation for firstName
  const handleContactChange = (index, field, value) => {
    const updatedContacts = [...contactEntries];
    updatedContacts[index] = {
      ...updatedContacts[index],
      [field]: value,
    };
    setContactEntries(updatedContacts);

    // Add validation for firstName
    if (field === "firstName") {
      const error = validateFirstName(value);
      setValidationErrors({
        ...validationErrors,
        [`firstName${index}`]: error,
      });
    } else if (field === "lastName") {
      const error = validateLastName(value);
      setValidationErrors({
        ...validationErrors,
        [`lastName${index}`]: error,
      });
    } else if (field === "phoneNumber") {
      const error = validateContactPhoneNumber(value);
      setValidationErrors({
        ...validationErrors,
        [`contactPhoneNumber${index}`]: error,
      });
    } else if (field === "email") {
      const error = validateContactEmailAddress(value);
      setValidationErrors({
        ...validationErrors,
        [`contactEmailAddress${index}`]: error,
      });
    } else if (field === "jobTitleId") {
      const error = value ? "" : "Job Title is required";
      setValidationErrors({
        ...validationErrors,
        [`jobTitle${index}`]: error,
      });
    }
  };

  // Add this new function after validateForm()
  const validateBranchDetailsTab = () => {
    // Check only the fields in the first tab
    const errors = {
      branchName: validateBranchName(formData.branchName),
      district: validateDistrict(formData.district),
      dscbname: formData.dscbname ? "" : "Bank Name is required",
      ifscCode: validateIFSCCode(formData.ifscCode),
      entryDate: validateDate(formData.entryDate),
      addressLine1: validateAddress(formData.addressLine1, "Address", true),
      pinCode: validatePinCode(formData.pinCode),
      city: validateCityOrMandal(formData.city, "City"),
      mandal: validateCityOrMandal(formData.mandal, "Mandal"),
      brphoneNumber: validateBrphoneNumber(formData.brphoneNumber),
      bremail: validateBranchEmail(formData.bremail),
      workingHours: validateWorkingHours(),
    };

    // Form is valid if no error messages exist
    return !Object.values(errors).some((error) => error !== "");
  };

  // Add a new contact entry
  const addContactEntry = () => {
    setContactEntries([
      ...contactEntries,
      {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        jobTitleId: "",
        seq: contactEntries.length + 1,
      },
    ]);
  };

  // Add this function after handleContactChange
  const deleteContactEntry = (indexToDelete) => {
    // Prevent deleting if there's only one contact entry left
    if (contactEntries.length <= 1) {
      return;
    }

    // Create a new array without the deleted contact
    const updatedContacts = contactEntries.filter(
      (_, index) => index !== indexToDelete
    );

    // Update the sequence numbers
    const resequencedContacts = updatedContacts.map((contact, index) => ({
      ...contact,
      seq: index + 1,
    }));

    // Update state with the filtered contacts
    setContactEntries(resequencedContacts);
    // Clear any validation errors for the deleted contact
    const updatedErrors = { ...validationErrors };
    delete updatedErrors[`firstName${indexToDelete}`];
    delete updatedErrors[`lastName${indexToDelete}`];
    delete updatedErrors[`contactPhoneNumber${indexToDelete}`];
    delete updatedErrors[`contactEmailAddress${indexToDelete}`];
    delete updatedErrors[`jobTitle${indexToDelete}`];
    setValidationErrors(updatedErrors);
  };

  const validateForm = () => {
    // Initialize all validation checks
    const errors = {
      branchName: validateBranchName(formData.branchName),
      district: validateDistrict(formData.district),
      ifscCode: validateIFSCCode(formData.ifscCode),
      entryDate: validateDate(formData.entryDate),
      addressLine1: validateAddress(formData.addressLine1, "Address", true),
      pinCode: validatePinCode(formData.pinCode),
      city: validateCityOrMandal(formData.city, "City"),
      mandal: validateCityOrMandal(formData.mandal, "Mandal"),
      brphoneNumber: validateBrphoneNumber(formData.brphoneNumber),
      bremail: validateBranchEmail(formData.bremail),
      workingHours: validateWorkingHours(),
      latitude: validateLatitude(formData.latitude),
      longitude: validateLongitude(formData.longitude),
    };

    // Contact validation - note that we need to check if any of these have issues
    contactEntries.forEach((contact, index) => {
      // Check each contact's required fields
      if (contact.firstName.trim() === "") {
        errors[`firstName${index}`] = "First Name is required";
      }

      // Add validation for other contact fields that might be required
      if (contact.phoneNumber.trim() === "") {
        errors[`contactPhoneNumber${index}`] =
          "Mobile/Landline Number is required";
      } else {
        errors[`contactPhoneNumber${index}`] = validateContactPhoneNumber(
          contact.phoneNumber
        );
      }

      if (contact.email.trim() === "") {
        errors[`contactEmailAddress${index}`] = "Email Address is required";
      } else {
        errors[`contactEmailAddress${index}`] = validateContactEmailAddress(
          contact.email
        );
      }

      // Check if job title is selected
      if (!contact.jobTitleId) {
        errors[`jobTitle${index}`] = "Job Title is required";
      }
    });

    // Check bank selection
    if (!formData.dscbname) {
      errors.dscbname = "Bank Name is required";
    }

    // Set all errors
    setValidationErrors(errors);

    // Debug log to see which validations are failing
    console.log("Validation errors:", errors);

    // Form is valid if no error messages exist
    return !Object.values(errors).some((error) => error !== "");
  };

  // Submit the form data
  const handleSubmit = async () => {
    if (!validateForm()) {
      console.log("Validation errors:", validationErrors);

      Object.entries(validationErrors).forEach(([field, error]) => {
        if (error) {
          console.log(`Field "${field}" error: ${error}`);
        }
      });

      toast.error("Please correct the validation errors", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      return;
    }

    setIsSubmitting(true);
    setLoader(true);

    try {
      // Get the branch ID from dataForEdit if it exists
      const branchId = branchData?.id || null;

      // Handle image data
      let imageData = null;

      if (logoFile) {
        // New file uploaded - convert to byte array
        imageData = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (event) => {
            const arrayBuffer = event.target.result;
            const byteArray = new Uint8Array(arrayBuffer);
            resolve(Array.from(byteArray)); // Convert to regular array for JSON serialization
          };
          reader.onerror = (error) => reject(error);
          reader.readAsArrayBuffer(logoFile);
        });
      } else if (existingImageData && !imageToRemove) {
        // Keep existing image data
        if (Array.isArray(existingImageData)) {
          // If it's already a byte array
          imageData = existingImageData;
        } else if (typeof existingImageData === "string") {
          // If it's a base64 string, convert to byte array
          try {
            const base64Data = existingImageData.includes(",")
              ? existingImageData.split(",")[1]
              : existingImageData;
            const binaryString = atob(base64Data);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
              bytes[i] = binaryString.charCodeAt(i);
            }
            imageData = Array.from(bytes);
          } catch (error) {
            console.error("Error converting base64 to byte array:", error);
            imageData = null;
          }
        }
      } else if (imageToRemove) {
        // Image was removed - send null
        imageData = null;
      }

      // Track deleted contacts (only for existing contacts that were deleted)
      const deletedContacts = [];
      if (branchData?.branch_contact) {
        // Find contacts that existed but are no longer in contactEntries
        branchData.branch_contact.forEach((existingContact) => {
          const stillExists = contactEntries.some(
            (contact) =>
              contact.seq === existingContact.seq || // For existing contacts that were modified
              (contact.id && contact.id === existingContact.id) // For contacts with IDs
          );

          if (!stillExists) {
            deletedContacts.push({
              id: existingContact.id,
              branch_id: branchId,
              firstName: existingContact.firstName,
              lastName: existingContact.lastName,
              phoneNumber: existingContact.phoneNumber,
              email: existingContact.email,
              seq: existingContact.seq,
              job_title_id: existingContact.job_title_id,
              is_deleted: true,
              updated_by: userId,
            });
          }
        });
      }

      // Create the work time entries
      const workTimeEntries = [];

      // First handle existing work times that might need to be marked as deleted
      if (branchData?.branch_work_time) {
        branchData.branch_work_time.forEach((existingWorkTime) => {
          const day = existingWorkTime.day;
          const currentDayDetails = workingDays[day];

          // If the day is unchecked now but existed before, mark it as deleted
          if (!currentDayDetails.checked) {
            workTimeEntries.push({
              id: existingWorkTime.id,
              branch_id: branchId,
              day,
              fromTime: existingWorkTime.fromTime,
              toTime: existingWorkTime.toTime,
              is_deleted: true, // This is the key change
              updated_by: userId,
            });
          }
        });
      }

      // Then add the checked days (new or updated)
      Object.entries(workingDays).forEach(([day, details]) => {
        if (details.checked) {
          // Find if this day already exists in branchData
          const existingWorkTime = branchData?.branch_work_time?.find(
            (wt) => wt.day === day
          );

          // Only add if it's not already marked as deleted above
          if (
            !existingWorkTime ||
            (existingWorkTime &&
              !workTimeEntries.some(
                (wt) => wt.id === existingWorkTime.id && wt.is_deleted
              ))
          ) {
            workTimeEntries.push({
              id: existingWorkTime ? existingWorkTime.id : null,
              branch_id: branchId,
              day,
              fromTime: details.fromTime + ":00",
              toTime: details.toTime + ":00",
              is_deleted: false,
              ...(existingWorkTime
                ? { updated_by: userId }
                : { created_by: userId }),
            });
          }
        }
      });

      // Create current contact entries
      const currentContactEntries = contactEntries
        .filter((contact) => contact.firstName || contact.lastName)
        .map((contact) => {
          const existingContact = branchData?.branch_contact?.find(
            (c) => (contact.id && c.id === contact.id) || c.seq === contact.seq
          );

          return {
            id: existingContact ? existingContact.id : null,
            branch_id: branchId,
            firstName: contact.firstName,
            lastName: contact.lastName,
            phoneNumber: contact.phoneNumber,
            email: contact.email,
            seq: contact.seq,
            is_deleted: false,
            job_title_id: Number(contact.jobTitleId),
            ...(existingContact
              ? { updated_by: userId }
              : { created_by: userId }),
          };
        });

      // Combine current and deleted contacts
      const allContactEntries = [...currentContactEntries, ...deletedContacts];

      // Build the complete payload
      const payload = {
        id: branchId, // This will be the branch_id for edit
        branchName: formData.branchName,
        district: formData.district,
        bankId: selectedBank?.id,
        ifscCode: formData.ifscCode,
        activeStatus: formData.activeStatus,
        entryDate: formData.entryDate,
        addressLine1: formData.addressLine1,
        addressLine2: formData.addressLine2,
        pinCode: formData.pinCode,
        city: formData.city,
        mandal: formData.mandal,
        state: "Bihar",
        phoneNumber: formData.brphoneNumber,
        email: formData.bremail,
        latitude: formData.latitude,
        longitude: formData.longitude,
        is_deleted: false,
        updated_by: userId, // For edit, we always use updated_by in the main object
        branch_work_time: workTimeEntries,
        branch_contact: allContactEntries,
        image: imageData,
        branchNameFontsize: `${fontStyles.branchNameFontSize}px`,
        branchNameColour: fontStyles.branchNameColor,
      };

      if (dataForEdit) {
        // EDIT operation - use putDataWithBody
        const response = await putDataWithBody(
          updateBranchDetails,
          payload,
          {}
        );

        if (response.status === "success") {
          toast.success("Branch updated successfully", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          navigate("../allbrancheslist");
          setTimeout(() => {
            window.location.reload();
          }, 100);
        } else {
          toast.error(response.msg || "Failed to update branch", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
        }
      } else {
        // CREATE operation - use postDataWithBody
        const response = await postDataWithBody(createBranch, payload, {});

        if (response.status === "success") {
          toast.success("Branch created successfully", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          navigate("../allbrancheslist");
          setTimeout(() => {
            window.location.reload();
          }, 100);
        } else {
          toast.error(response.msg || "Failed to create branch", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("An error occurred while submitting the form", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setLoader(false);
      setIsSubmitting(false);
    }
  };

  // Handle moving to next tab
  // Update handleNextTab to include validation
  const handleNextTab = () => {
    // Validate all fields in the first tab
    const branchTabErrors = {
      branchName: validateBranchName(formData.branchName),
      district: validateDistrict(formData.district),
      dscbname: formData.dscbname ? "" : "Bank Name is required",
      ifscCode: validateIFSCCode(formData.ifscCode),
      entryDate: validateDate(formData.entryDate),
      addressLine1: validateAddress(formData.addressLine1, "Address", true),
      pinCode: validatePinCode(formData.pinCode),
      city: validateCityOrMandal(formData.city, "City"),
      mandal: validateCityOrMandal(formData.mandal, "Mandal"),
      brphoneNumber: validateBrphoneNumber(formData.brphoneNumber),
      bremail: validateBranchEmail(formData.bremail),
      workingHours: validateWorkingHours(),
    };

    // Update validation errors
    setValidationErrors((prev) => ({ ...prev, ...branchTabErrors }));

    // Check if we can proceed
    if (!Object.values(branchTabErrors).some((error) => error !== "")) {
      document.getElementById("contact-details-tab").click();
    } else {
      toast.error("Please fill all required fields correctly", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };
  const handleCancelClick = () => {
    setShowCancelModal(true);
  };
  const handleConfirmCancel = () => {
    // Reset all form values
    setWorkingDays({
      Monday: { checked: false, fromTime: "", toTime: "" },
      Tuesday: { checked: false, fromTime: "", toTime: "" },
      Wednesday: { checked: false, fromTime: "", toTime: "" },
      Thursday: { checked: false, fromTime: "", toTime: "" },
      Friday: { checked: false, fromTime: "", toTime: "" },
      Saturday: { checked: false, fromTime: "", toTime: "" },
      Sunday: { checked: false, fromTime: "", toTime: "" },
    });

    // Form data state
    setFormData({
      branchName: "",
      district: "",
      bankId: null, // Default value
      ifscCode: "",
      activeStatus: false,
      entryDate: new Date().toISOString().split("T")[0],
      addressLine1: "",
      addressLine2: "",
      pinCode: "",
      city: "",
      mandal: "",
      state: "",
      brphoneNumber: "",
      bremail: "",
      latitude: "",
      longitude: "",
    });
    setFontStyles({
      branchNameFontSize: "18",
      branchNameColor: "#000000",
    });
    setValidationErrors({
      branchName: "",
      district: "",
      ifscCode: "",
      entryDate: "",
      addressLine1: "",
      pinCode: "",
      city: "",
      mandal: "",
      brphoneNumber: "",
      bremail: "",
      dscbname: "",
      firstName: "",
      lastName: "",
      contactPhoneNumber: "",
      contactEmailAddress: "",
    });
    setContactEntries([
      {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        jobTitleId: "",
        seq: 1,
      },
    ]);

    // Close the modal
    setShowCancelModal(false);
  };

  const mapCoordinates = [
    {
      x: formData.latitude,
      y: formData.longitude,
      locationId: 1,
    },
  ];

  return (
    <>
      {!mapview ? (
        <>
          <div className="branch-main-container">
            {/* Tab Navigation */}
            <ul className="branch-tab-buttons" id="branchTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="tab-button active"
                  id="branch-details-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#branch-details"
                  type="button"
                  role="tab"
                  aria-controls="branch-details"
                  aria-selected="true"
                >
                  Branch Details
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="tab-button"
                  id="contact-details-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#contact-details"
                  type="button"
                  role="tab"
                  aria-controls="contact-details"
                  aria-selected="false"
                >
                  Contact Details
                </button>
              </li>
            </ul>

            {/* Tab Content */}
            <div className="tab-content" id="branchTabContent">
              {/* Branch Details Tab */}
              <div
                className="tab-pane fade show active"
                id="branch-details"
                role="tabpanel"
                aria-labelledby="branch-details-tab"
              >
                <div className="main-container">
                  <div className="row">
                    <div className="col-8 mb-3">
                      <label htmlFor="branchName" className="form-label">
                        Branch Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.branchName ? "is-invalid" : ""
                        }`}
                        id="branchName"
                        value={formData.branchName}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                      />
                      {validationErrors.branchName && (
                        <div className="invalid-feedback">
                          {validationErrors.branchName}
                        </div>
                      )}
                    </div>

                    <div className="col-2 mb-3">
                      <label
                        htmlFor="branchNameFontSize"
                        className="form-label"
                      >
                        Font Size (px)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        min="18"
                        max="30"
                        step="1"
                        value={fontStyles.branchNameFontSize}
                        onChange={(e) => {
                          let value = e.target.value;
                          // Ensure value is between 8 and 72
                          if (value > 30) value = 30;
                          if (value < 18) value = 18;
                          setFontStyles({
                            ...fontStyles,
                            branchNameFontSize: value,
                          });
                        }}
                        disabled={isTextFieldDisable}
                      />
                    </div>
                    <div className="col-2 mb-3">
                      <label htmlFor="branchNameColor" className="form-label">
                        Font Color
                        <i
                          className="bi bi-eyedropper"
                          style={{
                            paddingLeft: "5px",
                            fontSize: "16px",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            document.getElementById("branchNameColor").click()
                          }
                        ></i>
                      </label>
                      <input
                        type="color"
                        id="branchNameColor"
                        style={{ width: "50%" }}
                        className="form-control form-control-sm p-1"
                        value={fontStyles.branchNameColor}
                        onChange={(e) =>
                          setFontStyles({
                            ...fontStyles,
                            branchNameColor: e.target.value,
                          })
                        }
                        disabled={isTextFieldDisable}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-3 mb-3">
                      <label htmlFor="dscbname" className="form-label">
                        Bank Name<span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-select branch-input-form-control font-size-14 ${
                          validationErrors.dscbname ? "is-invalid" : ""
                        }`}
                        id="dscbname"
                        value={formData.dscbname}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                      >
                        <option value="">Select Bank</option>
                        {banksList.map((bank) => (
                          <option key={bank.id} value={bank.id}>
                            {bank.bankName}
                          </option>
                        ))}
                      </select>
                      {validationErrors.dscbname && (
                        <div className="invalid-feedback">
                          {validationErrors.dscbname}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="ifscCode" className="form-label">
                        IFSC Code<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.ifscCode ? "is-invalid" : ""
                        }`}
                        id="ifscCode"
                        value={formData.ifscCode}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                      />
                      {validationErrors.ifscCode && (
                        <div className="invalid-feedback">
                          {validationErrors.ifscCode}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="activationDate" className="form-label">
                        Active Status
                      </label>
                      <div className="d-flex align-items-center gap-2">
                        <input
                          className="form-check-input branch-active-status-checkbox"
                          type="checkbox"
                          id="activeStatusCheck"
                          checked={formData.activeStatus}
                          onChange={handleInputChange}
                          disabled={isTextFieldDisable}
                        />
                        <input
                          type="date"
                          className={`custom-date-input form-control ${
                            validationErrors.entryDate ? "is-invalid" : ""
                          }`}
                          id="entryDate"
                          style={{paddingBottom: "7px"}}
                          value={formData.entryDate}
                          onChange={handleInputChange}
                          disabled={isTextFieldDisable}
                          max={today}
                        />
                        {validationErrors.entryDate && (
                          <div className="invalid-feedback">
                            {validationErrors.entryDate}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="section-header-branch">
                    <span className="uline">Branch Address</span>
                  </div>
                  <div className="row">
                    <div className="col-3 mb-3">
                      <label htmlFor="addressLine1" className="form-label">
                        Address<span className="text-danger">*</span>
                      </label>
                      <textarea
                        // type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.addressLine1 ? "is-invalid" : ""
                        }`}
                        id="addressLine1"
                        value={formData.addressLine1}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        rows={3}
                      />
                      {validationErrors.addressLine1 && (
                        <div className="invalid-feedback">
                          {validationErrors.addressLine1}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="mandal" className="form-label">
                        Mandal<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.mandal ? "is-invalid" : ""
                        }`}
                        id="mandal"
                        value={formData.mandal}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        maxLength={50}
                      />
                      {validationErrors.mandal && (
                        <div className="invalid-feedback">
                          {validationErrors.mandal}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="city" className="form-label">
                        City<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.city ? "is-invalid" : ""
                        }`}
                        id="city"
                        value={formData.city}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        maxLength={50}
                      />
                      {validationErrors.city && (
                        <div className="invalid-feedback">
                          {validationErrors.city}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="district" className="form-label">
                        District<span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-select branch-input-form-control font-size-14 ${
                          validationErrors.district ? "is-invalid" : ""
                        }`}
                        id="district"
                        value={formData.district}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                      >
                        <option value="">Select District</option>
                        {districtList.map((district) => (
                          <option key={district.id} value={district.value}>
                            {district.value}
                          </option>
                        ))}
                      </select>
                      {validationErrors.district && (
                        <div className="invalid-feedback">
                          {validationErrors.district}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-3 mb-3">
                      <label htmlFor="pinCode" className="form-label">
                        Pincode<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.pinCode ? "is-invalid" : ""
                        }`}
                        id="pinCode"
                        value={formData.pinCode}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        maxLength={6}
                      />
                      {validationErrors.pinCode && (
                        <div className="invalid-feedback">
                          {validationErrors.pinCode}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="latitude" className="form-label">
                        Latitude
                      </label>

                      <input
                        type="text"
                        className="form-control branch-input-form-control"
                        id="latitude"
                        value={formData.latitude}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        readOnly
                      />
                      {validationErrors.latitude && (
                        <div className="text-danger small">
                          {validationErrors.latitude}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <label htmlFor="longitude" className="form-label">
                          Longitude
                        </label>
                        <span
                          className="text-primary"
                          onClick={
                            !isTextFieldDisable ? openMapModal : undefined
                          }
                          style={{
                            fontSize: "14px",
                            cursor: isTextFieldDisable
                              ? "not-allowed"
                              : "pointer",
                            opacity: isTextFieldDisable ? 0.5 : 1,
                          }}
                        >
                          Locate on map
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control branch-input-form-control"
                        id="longitude"
                        value={formData.longitude}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        readOnly
                      />
                      {validationErrors.longitude && (
                        <div className="text-danger small">
                          {validationErrors.longitude}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="section-header-branch">
                    <span className="uline">Branch Contact Details</span>
                  </div>
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label htmlFor="brphoneNumber" className="form-label">
                        Mobile/Landline Number
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.brphoneNumber ? "is-invalid" : ""
                        }`}
                        id="brphoneNumber"
                        value={formData.brphoneNumber}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                      />
                      {validationErrors.brphoneNumber && (
                        <div className="invalid-feedback">
                          {validationErrors.brphoneNumber}
                        </div>
                      )}
                    </div>
                    <div className="col-6 mb-3">
                      <label htmlFor="bremail" className="form-label">
                        Email Address<span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className={`form-control branch-input-form-control ${
                          validationErrors.bremail ? "is-invalid" : ""
                        }`}
                        id="bremail"
                        value={formData.bremail}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                      />
                      {validationErrors.bremail && (
                        <div className="invalid-feedback">
                          {validationErrors.bremail}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label htmlFor="branchLogo" className="form-label">
                        Branch Logo
                      </label>
                      <input
                        type="file"
                        id="branchLogo"
                        accept=".jpg, .jpeg, .png, .svg, image/jpeg, image/png, image/svg+xml"
                        onChange={handleLogoChange}
                        className="form-control branch-input-form-control"
                      />
                      {logoPreview && (
                        <div
                          className="mt-2 position-relative"
                          style={{ width: "100px", height: "100px" }}
                        >
                          <img
                            src={logoPreview}
                            alt="Branch Logo Preview"
                            className="img-thumbnail"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                          />
                          {!isTextFieldDisable && (
                            <button
                              onClick={handleLogoRemove}
                              className="position-absolute top-0 end-0 bg-danger border-0 rounded-circle p-0"
                              style={{
                                width: "24px",
                                height: "24px",
                                transform: "translate(50%, -50%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              aria-label="Remove logo"
                            >
                              <span
                                style={{ color: "white", fontSize: "12px" }}
                              >
                                ×
                              </span>
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="section-header-branch">
                    <span className="uline">Working Timings</span>
                  </div>
                  <div className="section-subheader-branch">
                    <span className="text-gray">
                      Select Days and Timings
                      <span className="text-danger">*</span>
                    </span>
                  </div>

                  {/* Display validation error message outside the cards */}
                  {validationErrors.workingHours && (
                    <div className="text-danger mb-3">
                      {validationErrors.workingHours}
                    </div>
                  )}

                  <div className="d-flex flex-wrap justify-content-between gap-0">
                    {Object.entries(workingDays).map(([day, details]) => (
                      <div
                        key={day}
                        className="branch-time-card-container mb-4 border rounded p-3"
                      >
                        <div className="d-flex align-items-center justify-content-center mb-3">
                          <h5 className="branch-time-title d-flex align-items-center gap-2 m-0">
                            <input
                              className="form-check-input mt-0 branch-time-checkbox"
                              type="checkbox"
                              checked={details.checked}
                              onChange={(e) =>
                                handleWorkingDayChange(day, "checked", e)
                              }
                              disabled={isTextFieldDisable}
                            />
                            {day}
                          </h5>
                        </div>
                        <div className="row">
                          <div className="col mb-3 text-center">
                            <label
                              htmlFor={`${day.toLowerCase()}FromTime`}
                              className="branch-form-label"
                            >
                              From
                            </label>
                            {isTextFieldDisable || !details.checked ? (
                              <input
                                type="text"
                                className="form-control branch-input-form-control"
                                value={details.fromTime}
                                disabled={true}
                              />
                            ) : (
                              <input
                                type="time"
                                className="form-control branch-input-form-control"
                                id={`${day.toLowerCase()}FromTime`}
                                value={details.fromTime}
                                onChange={(e) =>
                                  handleWorkingDayChange(day, "fromTime", e)
                                }
                              />
                            )}
                            <label
                              htmlFor={`${day.toLowerCase()}ToTime`}
                              className="branch-form-label mt-2"
                            >
                              To
                            </label>
                            {isTextFieldDisable || !details.checked ? (
                              <input
                                type="text"
                                className="form-control branch-input-form-control"
                                value={details.toTime}
                                disabled={true}
                              />
                            ) : (
                              <input
                                type="time"
                                className="form-control branch-input-form-control"
                                id={`${day.toLowerCase()}ToTime`}
                                value={details.toTime}
                                onChange={(e) =>
                                  handleWorkingDayChange(day, "toTime", e)
                                }
                              />
                            )}
                            {/* Removed validation error display from inside each card */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {mapview && (
                    <div style={{ width: "50%", height: "100%" }}>
                      <MapWrapperForEdit
                        // bankEdit={true}
                        title="Incidents"
                        containerStyles={{
                          height: "60%",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "column",
                        }}
                        headerStyles={{
                          backgroundColor: "#1a7a73",
                          color: "white",
                          padding: "8px 16px",
                        }}
                        bodyStyles={{
                          flex: 1,
                          overflow: "hidden",
                        }}
                        coordinates={mapCoordinates}
                        zoom={13}
                        popUpShow={true}
                      />
                    </div>
                  )}

                  <div className="d-flex justify-content-end">
                    <button
                      className="branch-next-btn btn btn-primary"
                      onClick={handleNextTab}
                      disabled={
                        isSubmitting ||
                        isTextFieldDisable ||
                        !validateBranchDetailsTab()
                      }
                    >
                      Next
                    </button>
                    <button
                      className="branch-next-btn btn btn-primary"
                      onClick={handleCancelClick}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>

              {/* Contact Details Tab */}
              <div
                className="tab-pane fade"
                id="contact-details"
                role="tabpanel"
                aria-labelledby="contact-details-tab"
              >
                <div className="main-container">
                  {contactEntries.map((contact, index) => (
                    <div key={index}>
                      <div className="section-header-branch d-flex justify-content-between align-items-center">
                        <span className="uline">
                          Contact Details {index + 1}
                        </span>
                        {index > 0 && !isTextFieldDisable && (
                          // <button
                          //   type="button"
                          //   className="btn btn-outline-danger btn-sm"
                          //   onClick={() => deleteContactEntry(index)}
                          //   disabled={isSubmitting}
                          // ><i className="bi bi-trash"></i></button>
                          <i
                            className="bi bi-trash"
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => deleteContactEntry(index)}
                            disabled={isSubmitting}
                          ></i>
                        )}
                      </div>
                      <div className="row gap-0">
                        <div className="col-6 mb-3">
                          <label
                            htmlFor={`firstName${index + 1}`}
                            className="form-label"
                          >
                            First Name<span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control branch-input-form-control ${
                              validationErrors[`firstName${index}`]
                                ? "is-invalid"
                                : ""
                            }`}
                            id={`firstName${index + 1}`}
                            value={contact.firstName}
                            onChange={(e) =>
                              handleContactChange(
                                index,
                                "firstName",
                                e.target.value
                              )
                            }
                            disabled={isTextFieldDisable}
                          />
                          {validationErrors[`firstName${index}`] && (
                            <div className="invalid-feedback">
                              {validationErrors[`firstName${index}`]}
                            </div>
                          )}
                        </div>
                        <div className="col-6 mb-3">
                          <label
                            htmlFor={`lastName${index + 1}`}
                            className="form-label"
                          >
                            Last Name
                          </label>
                          <input
                            type="text"
                            className={`form-control branch-input-form-control ${
                              validationErrors[`lastName${index}`]
                                ? "is-invalid"
                                : ""
                            }`}
                            id={`lastName${index + 1}`}
                            value={contact.lastName}
                            onChange={(e) =>
                              handleContactChange(
                                index,
                                "lastName",
                                e.target.value
                              )
                            }
                            disabled={isTextFieldDisable}
                          />
                          {validationErrors[`lastName${index}`] && (
                            <div className="invalid-feedback">
                              {validationErrors[`lastName${index}`]}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row gap-0">
                        <div className="col-6 mb-3">
                          <label
                            htmlFor={`phoneNumber${index + 1}`}
                            className="form-label"
                          >
                            Mobile/Landline Number
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control branch-input-form-control ${
                              validationErrors[`contactPhoneNumber${index}`]
                                ? "is-invalid"
                                : ""
                            }`}
                            id={`phoneNumber${index + 1}`}
                            value={contact.phoneNumber}
                            onChange={(e) =>
                              handleContactChange(
                                index,
                                "phoneNumber",
                                e.target.value
                              )
                            }
                            disabled={isTextFieldDisable}
                          />
                          {validationErrors[`contactPhoneNumber${index}`] && (
                            <div className="invalid-feedback">
                              {validationErrors[`contactPhoneNumber${index}`]}
                            </div>
                          )}
                        </div>
                        <div className="col-6 mb-3">
                          <label
                            htmlFor={`emailAddress${index + 1}`}
                            className="form-label"
                          >
                            Email Address<span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            className={`form-control branch-input-form-control ${
                              validationErrors[`contactEmailAddress${index}`]
                                ? "is-invalid"
                                : ""
                            }`}
                            id={`emailAddress${index + 1}`}
                            value={contact.email}
                            onChange={(e) =>
                              handleContactChange(
                                index,
                                "email",
                                e.target.value
                              )
                            }
                            disabled={isTextFieldDisable}
                          />
                          {validationErrors[`contactEmailAddress${index}`] && (
                            <div className="invalid-feedback">
                              {validationErrors[`contactEmailAddress${index}`]}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="row gap-0">
                        <div className="col-6 mb-3">
                          <label
                            htmlFor={`jobTitle${index + 1}`}
                            className="form-label"
                          >
                            Job Title<span className="text-danger">*</span>
                          </label>
                          <select
                            className={`form-select branch-input-form-control font-size-14 ${
                              validationErrors[`jobTitle${index}`]
                                ? "is-invalid"
                                : ""
                            }`}
                            id={`jobTitle${index + 1}`}
                            value={contact.jobTitleId || ""}
                            onChange={(e) =>
                              handleContactChange(
                                index,
                                "jobTitleId",
                                e.target.value
                              )
                            }
                            disabled={isTextFieldDisable}
                          >
                            <option value="">Select Job Title</option>
                            {jobTitleList.map((jobTitle) => (
                              <option key={jobTitle.id} value={jobTitle.id}>
                                {jobTitle.value}
                              </option>
                            ))}
                          </select>
                          {validationErrors[`jobTitle${index}`] && (
                            <div className="invalid-feedback">
                              {validationErrors[`jobTitle${index}`]}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                  {!isTextFieldDisable && (
                    <div
                      className="d-flex justify-content-end"
                      style={{ marginTop: "-58px" }}
                    >
                      <button
                        className="branch-add-more-btn btn btn-secondary"
                        onClick={addContactEntry}
                        disabled={isSubmitting || contactEntries.length >= 5}
                      >
                        + Add More
                      </button>
                    </div>
                  )}

                  <div className="d-flex justify-content-center mt-3">
                    <button
                      className="branch-save-submit-btn btn btn-success"
                      onClick={handleSubmit}
                      disabled={isSubmitting || isTextFieldDisable}
                    >
                      {isSubmitting ? "Submitting..." : "Save & Submit"}
                    </button>
                    <button
                      className="branch-save-submit-btn btn btn-success"
                      onClick={handleCancelClick}
                      style={{ marginLeft: "15px" }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Display loading indicator */}
          {loader && (
            <div className="loader-container">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}

          {showMapModal && (
            <Modal
              className="modal-position"
              size="lg"
              show={showMapModal}
              onHide={closeMapModal}
              aria-labelledby="example-modal-sizes-title-lg"
              right
            >
              <Modal.Header>
                <Modal.Title
                  id="example-modal-sizes-title-lg"
                  style={{ color: "#001b30", marginRight: "500px" }}
                >
                  {"Choose Location"}
                </Modal.Title>
                <XCircleblack
                  className="cursor-pointer"
                  onClick={closeMapModal}
                  width="1.5em"
                  height="1.5em"
                  style={{ color: "#001b30" }}
                />
              </Modal.Header>
              <Modal.Body>
                <div className="gis-mapcontainer">
                  {/* <LocationAutoComplete updateMapLocation={updateMapLocation} /> */}

                  <div key={mapKey} className="assetFormMap">
                    <MapWrapper
                      headerStyles={{ display: "none" }}
                      coordinates={coordinates}
                      chooseCoordinates={chooseCoordinates}
                      zoom={zoomLevel}
                      closeMapModal={closeMapModal}
                    />
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          )}
          <Modal
            show={showCancelModal}
            onHide={() => setShowCancelModal(false)}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirm </Modal.Title>
            </Modal.Header>
            <Modal.Body>Would you like to clear the input values?</Modal.Body>
            <Modal.Footer>
              <button
                className="btn"
                style={{
                  backgroundColor: "lightgray",
                  color: "#000",
                  marginRight: "10px",
                }}
                onClick={() => setShowCancelModal(false)}
              >
                No
              </button>
              <button
                className="btn"
                style={{
                  backgroundColor: "green",
                  color: "#fff",
                }}
                onClick={handleConfirmCancel}
              >
                Yes
              </button>
            </Modal.Footer>
          </Modal>
          <ToastContainer />
        </>
      ) : (
        <>
          <div className="branch-main-container">
            {/* Tab Navigation */}
            <ul className="branch-tab-buttons" id="branchTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="tab-button active"
                  id="branch-details-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#branch-details"
                  type="button"
                  role="tab"
                  aria-controls="branch-details"
                  aria-selected="true"
                >
                  Branch Details
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="tab-button"
                  id="contact-details-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#contact-details"
                  type="button"
                  role="tab"
                  aria-controls="contact-details"
                  aria-selected="false"
                >
                  Contact Details
                </button>
              </li>
            </ul>

            {/* Tab Content */}
            <div className="tab-content" id="branchTabContent">
              {/* Branch Details Tab */}
              <div
                className="tab-pane fade show active"
                id="branch-details"
                role="tabpanel"
                aria-labelledby="branch-details-tab"
              >
                <div className="main-container">
                  <div className="row">
                    <div className="col-8 mb-3">
                      <label htmlFor="branchName" className="form-label">
                        Branch Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.branchName ? "is-invalid" : ""
                        }`}
                        id="branchName"
                        value={formData.branchName}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                      />
                      {validationErrors.branchName && (
                        <div className="invalid-feedback">
                          {validationErrors.branchName}
                        </div>
                      )}
                    </div>
                    <div className="col-2 mb-3">
                      <label
                        htmlFor="branchNameFontSize"
                        className="form-label"
                      >
                        Font Size (px)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        min="18"
                        max="30"
                        step="1"
                        value={fontStyles.branchNameFontSize}
                        onChange={(e) => {
                          let value = e.target.value;
                          // Ensure value is between 8 and 72
                          if (value > 30) value = 30;
                          if (value < 18) value = 18;
                          setFontStyles({
                            ...fontStyles,
                            branchNameFontSize: value,
                          });
                        }}
                        disabled={isTextFieldDisable}
                      />
                    </div>
                    <div className="col-2 mb-3">
                      <label htmlFor="branchNameColor" className="form-label">
                        Font Color
                        <i
                          className="bi bi-eyedropper"
                          style={{
                            paddingLeft: "5px",
                            fontSize: "16px",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            document.getElementById("branchNameColor").click()
                          }
                        ></i>
                      </label>
                      <input
                        type="color"
                        id="branchNameColor"
                        className="form-control form-control-color p-1"
                        style={{ width: "50%" }}
                        value={fontStyles.branchNameColor}
                        onChange={(e) =>
                          setFontStyles({
                            ...fontStyles,
                            branchNameColor: e.target.value,
                          })
                        }
                        disabled={isTextFieldDisable}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-3 mb-3">
                      <label htmlFor="dscbname" className="form-label">
                        Bank Name<span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-select branch-input-form-control font-size-14 ${
                          validationErrors.dscbname ? "is-invalid" : ""
                        }`}
                        id="dscbname"
                        value={formData.dscbname}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        style={dataForEdit ? { pointerEvents: 'none', backgroundColor: 'white', color: 'inherit',opacity:"0.4" } : {}}
                      >
                        <option value="">Select Bank</option>
                        {banksList.map((bank) => (
                          <option key={bank.id} value={bank.id}>
                            {bank.bankName}
                          </option>
                        ))}
                      </select>
                      {validationErrors.dscbname && (
                        <div className="invalid-feedback">
                          {validationErrors.dscbname}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="ifscCode" className="form-label">
                        IFSC Code<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.ifscCode ? "is-invalid" : ""
                        }`}
                        id="ifscCode"
                        value={formData.ifscCode}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                      />
                      {validationErrors.ifscCode && (
                        <div className="invalid-feedback">
                          {validationErrors.ifscCode}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="activationDate" className="form-label">
                        Active Status
                      </label>
                      <div className="d-flex align-items-center gap-2">
                        <input
                          className="form-check-input branch-active-status-checkbox"
                          type="checkbox"
                          id="activeStatusCheck"
                          checked={formData.activeStatus}
                          onChange={handleInputChange}
                          disabled={isTextFieldDisable}
                        />
                        <input
                          type="date"
                          className={`custom-date-input form-control ${
                            validationErrors.entryDate ? "is-invalid" : ""
                          }`}
                          id="entryDate"
                          style={{paddingBottom: "7px"}}
                          value={formData.entryDate}
                          onChange={handleInputChange}
                          disabled={isTextFieldDisable}
                          max={today}
                        />
                        {validationErrors.entryDate && (
                          <div className="invalid-feedback">
                            {validationErrors.entryDate}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="section-header-branch">
                    <span className="uline">Branch Address</span>
                  </div>
                  <div className="row">
                    <div className="col-3 mb-3">
                      <label htmlFor="addressLine1" className="form-label">
                        Address<span className="text-danger">*</span>
                      </label>
                      <textarea
                        // type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.addressLine1 ? "is-invalid" : ""
                        }`}
                        id="addressLine1"
                        value={formData.addressLine1}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        rows={3}
                      />
                      {validationErrors.addressLine1 && (
                        <div className="invalid-feedback">
                          {validationErrors.addressLine1}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="mandal" className="form-label">
                        Mandal<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.mandal ? "is-invalid" : ""
                        }`}
                        id="mandal"
                        value={formData.mandal}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        maxLength={50}
                      />
                      {validationErrors.mandal && (
                        <div className="invalid-feedback">
                          {validationErrors.mandal}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="city" className="form-label">
                        City<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.city ? "is-invalid" : ""
                        }`}
                        id="city"
                        value={formData.city}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        maxLength={50}
                      />
                      {validationErrors.city && (
                        <div className="invalid-feedback">
                          {validationErrors.city}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="district" className="form-label">
                        District<span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-select branch-input-form-control font-size-14 ${
                          validationErrors.district ? "is-invalid" : ""
                        }`}
                        id="district"
                        value={formData.district}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                      >
                        <option value="">Select District</option>
                        {districtList.map((district) => (
                          <option key={district.id} value={district.value}>
                            {district.value}
                          </option>
                        ))}
                      </select>
                      {validationErrors.district && (
                        <div className="invalid-feedback">
                          {validationErrors.district}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label htmlFor="pinCode" className="form-label">
                        Pincode<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.pinCode ? "is-invalid" : ""
                        }`}
                        id="pinCode"
                        value={formData.pinCode}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        maxLength={6}
                        style={{ width: "243px" }}
                      />
                      {validationErrors.pinCode && (
                        <div className="invalid-feedback">
                          {validationErrors.pinCode}
                        </div>
                      )}
                    </div>
                    <div className="col-6 mb-3">
                      {mapview && (
                        <div className="xyzMap">
                          <MapWrapperForEdit
                            bankEdit={true}
                            title="Incidents"
                            containerStyles={{
                              height: "60%",
                              borderRadius: "10px",
                              display: "flex",
                              flexDirection: "column",
                            }}
                            headerStyles={{
                              backgroundColor: "#1a7a73",
                              color: "white",
                              padding: "8px 16px",
                            }}
                            bodyStyles={{
                              flex: 1,
                              overflow: "hidden",
                            }}
                            coordinates={mapCoordinates}
                            zoom={13}
                            popUpShow={true}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: "-27rem" }}>
                    <div className="col-3 mb-3">
                      <label htmlFor="latitude" className="form-label">
                        Latitude
                      </label>

                      <input
                        type="text"
                        className="form-control branch-input-form-control"
                        id="latitude"
                        value={formData.latitude}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        readOnly
                      />
                      {validationErrors.latitude && (
                        <div className="text-danger small">
                          {validationErrors.latitude}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <label htmlFor="longitude" className="form-label">
                          Longitude
                        </label>
                        <span
                          className="text-primary"
                          onClick={
                            !isTextFieldDisable ? openMapModal : undefined
                          }
                          style={{
                            fontSize: "14px",
                            cursor: isTextFieldDisable
                              ? "not-allowed"
                              : "pointer",
                            opacity: isTextFieldDisable ? 0.5 : 1,
                          }}
                        >
                          Locate on map
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control branch-input-form-control"
                        id="longitude"
                        value={formData.longitude}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        readOnly
                      />
                      {validationErrors.longitude && (
                        <div className="text-danger small">
                          {validationErrors.longitude}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="section-header-branch">
                    <span className="uline">Branch Contact Details</span>
                  </div>
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label htmlFor="brphoneNumber" className="form-label">
                        Mobile/Landline Number
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.brphoneNumber ? "is-invalid" : ""
                        }`}
                        id="brphoneNumber"
                        value={formData.brphoneNumber}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                      />
                      {validationErrors.brphoneNumber && (
                        <div className="invalid-feedback">
                          {validationErrors.brphoneNumber}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label htmlFor="bremail" className="form-label">
                        Email Address<span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className={`form-control branch-input-form-control ${
                          validationErrors.bremail ? "is-invalid" : ""
                        }`}
                        id="bremail"
                        value={formData.bremail}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                      />
                      {validationErrors.bremail && (
                        <div className="invalid-feedback">
                          {validationErrors.bremail}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label htmlFor="branchLogo" className="form-label">
                        Branch Logo
                      </label>
                      <input
                        type="file"
                        id="branchLogo"
                        accept=".jpg, .jpeg, .png, .svg, image/jpeg, image/png, image/svg+xml"
                        onChange={handleLogoChange}
                        className="form-control branch-input-form-control"
                      />
                      {logoPreview && (
                        <div
                          className="mt-2 position-relative"
                          style={{ width: "100px", height: "100px" }}
                        >
                          <img
                            src={logoPreview}
                            alt="Branch Logo Preview"
                            className="img-thumbnail"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                          />
                          {!isTextFieldDisable && (
                            <button
                              onClick={handleLogoRemove}
                              className="position-absolute top-0 end-0 bg-danger border-0 rounded-circle p-0"
                              style={{
                                width: "24px",
                                height: "24px",
                                transform: "translate(50%, -50%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              aria-label="Remove logo"
                            >
                              <span
                                style={{ color: "white", fontSize: "12px" }}
                              >
                                ×
                              </span>
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="section-header-branch">
                    <span className="uline">Working Timings</span>
                  </div>
                  <div className="section-subheader-branch">
                    <span className="text-gray">
                      Select Days and Timings
                      <span className="text-danger">*</span>
                    </span>
                  </div>

                  {/* Display validation error message outside the cards */}
                  {validationErrors.workingHours && (
                    <div className="text-danger mb-3">
                      {validationErrors.workingHours}
                    </div>
                  )}

                  <div className="d-flex flex-wrap justify-content-between gap-0">
                    {Object.entries(workingDays).map(([day, details]) => (
                      <div
                        key={day}
                        className="branch-time-card-container mb-4 border rounded p-3"
                      >
                        <div className="d-flex align-items-center justify-content-center mb-3">
                          <h5 className="branch-time-title d-flex align-items-center gap-2 m-0">
                            <input
                              className="form-check-input mt-0 branch-time-checkbox"
                              type="checkbox"
                              checked={details.checked}
                              onChange={(e) =>
                                handleWorkingDayChange(day, "checked", e)
                              }
                              disabled={isTextFieldDisable}
                            />
                            {day}
                          </h5>
                        </div>
                        <div className="row">
                          <div className="col mb-3 text-center">
                            <label
                              htmlFor={`${day.toLowerCase()}FromTime`}
                              className="branch-form-label"
                            >
                              From
                            </label>
                            {isTextFieldDisable || !details.checked ? (
                              <input
                                type="text"
                                className="form-control branch-input-form-control"
                                value={details.fromTime}
                                disabled={true}
                              />
                            ) : (
                              <input
                                type="time"
                                className="form-control branch-input-form-control"
                                id={`${day.toLowerCase()}FromTime`}
                                value={details.fromTime}
                                onChange={(e) =>
                                  handleWorkingDayChange(day, "fromTime", e)
                                }
                              />
                            )}
                            <label
                              htmlFor={`${day.toLowerCase()}ToTime`}
                              className="branch-form-label mt-2"
                            >
                              To
                            </label>
                            {isTextFieldDisable || !details.checked ? (
                              <input
                                type="text"
                                className="form-control branch-input-form-control"
                                value={details.toTime}
                                disabled={true}
                              />
                            ) : (
                              <input
                                type="time"
                                className="form-control branch-input-form-control"
                                id={`${day.toLowerCase()}ToTime`}
                                value={details.toTime}
                                onChange={(e) =>
                                  handleWorkingDayChange(day, "toTime", e)
                                }
                              />
                            )}
                            {/* Removed validation error display from inside each card */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="d-flex justify-content-end">
                    <button
                      className="branch-next-btn btn btn-primary"
                      onClick={handleNextTab}
                      disabled={
                        isSubmitting ||
                        isTextFieldDisable ||
                        !validateBranchDetailsTab()
                      }
                    >
                      Next
                    </button>
                    {/* <button
                  className="branch-next-btn btn btn-primary"
                  onClick={handleCancelClick}
                >
                  Cancel
                </button> */}
                  </div>
                </div>
              </div>

              {/* Contact Details Tab */}
              <div
                className="tab-pane fade"
                id="contact-details"
                role="tabpanel"
                aria-labelledby="contact-details-tab"
              >
                <div className="main-container">
                  {contactEntries.map((contact, index) => (
                    <div key={index}>
                      <div className="section-header-branch d-flex justify-content-between align-items-center">
                        <span className="uline">
                          Contact Details {index + 1}
                        </span>
                        {index > 0 && !isTextFieldDisable && (
                          // <button
                          //   type="button"
                          //   className="btn btn-outline-danger btn-sm"
                          //   onClick={() => deleteContactEntry(index)}
                          //   disabled={isSubmitting}
                          // ><i className="bi bi-trash"></i></button>
                          <i
                            className="bi bi-trash"
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => deleteContactEntry(index)}
                            disabled={isSubmitting}
                          ></i>
                        )}
                      </div>
                      <div className="row gap-0">
                        <div className="col-6 mb-3">
                          <label
                            htmlFor={`firstName${index + 1}`}
                            className="form-label"
                          >
                            First Name<span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control branch-input-form-control ${
                              validationErrors[`firstName${index}`]
                                ? "is-invalid"
                                : ""
                            }`}
                            id={`firstName${index + 1}`}
                            value={contact.firstName}
                            onChange={(e) =>
                              handleContactChange(
                                index,
                                "firstName",
                                e.target.value
                              )
                            }
                            disabled={isTextFieldDisable}
                          />
                          {validationErrors[`firstName${index}`] && (
                            <div className="invalid-feedback">
                              {validationErrors[`firstName${index}`]}
                            </div>
                          )}
                        </div>
                        <div className="col-6 mb-3">
                          <label
                            htmlFor={`lastName${index + 1}`}
                            className="form-label"
                          >
                            Last Name
                          </label>
                          <input
                            type="text"
                            className={`form-control branch-input-form-control ${
                              validationErrors[`lastName${index}`]
                                ? "is-invalid"
                                : ""
                            }`}
                            id={`lastName${index + 1}`}
                            value={contact.lastName}
                            onChange={(e) =>
                              handleContactChange(
                                index,
                                "lastName",
                                e.target.value
                              )
                            }
                            disabled={isTextFieldDisable}
                          />
                          {validationErrors[`lastName${index}`] && (
                            <div className="invalid-feedback">
                              {validationErrors[`lastName${index}`]}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row gap-0">
                        <div className="col-6 mb-3">
                          <label
                            htmlFor={`phoneNumber${index + 1}`}
                            className="form-label"
                          >
                            Mobile/Landline Number
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control branch-input-form-control ${
                              validationErrors[`contactPhoneNumber${index}`]
                                ? "is-invalid"
                                : ""
                            }`}
                            id={`phoneNumber${index + 1}`}
                            value={contact.phoneNumber}
                            onChange={(e) =>
                              handleContactChange(
                                index,
                                "phoneNumber",
                                e.target.value
                              )
                            }
                            disabled={isTextFieldDisable}
                          />
                          {validationErrors[`contactPhoneNumber${index}`] && (
                            <div className="invalid-feedback">
                              {validationErrors[`contactPhoneNumber${index}`]}
                            </div>
                          )}
                        </div>
                        <div className="col-6 mb-3">
                          <label
                            htmlFor={`emailAddress${index + 1}`}
                            className="form-label"
                          >
                            Email Address<span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            className={`form-control branch-input-form-control ${
                              validationErrors[`contactEmailAddress${index}`]
                                ? "is-invalid"
                                : ""
                            }`}
                            id={`emailAddress${index + 1}`}
                            value={contact.email}
                            onChange={(e) =>
                              handleContactChange(
                                index,
                                "email",
                                e.target.value
                              )
                            }
                            disabled={isTextFieldDisable}
                          />
                          {validationErrors[`contactEmailAddress${index}`] && (
                            <div className="invalid-feedback">
                              {validationErrors[`contactEmailAddress${index}`]}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="row gap-0">
                        <div className="col-6 mb-3">
                          <label
                            htmlFor={`jobTitle${index + 1}`}
                            className="form-label"
                          >
                            Job Title<span className="text-danger">*</span>
                          </label>
                          <select
                            className={`form-select branch-input-form-control font-size-14 ${
                              validationErrors[`jobTitle${index}`]
                                ? "is-invalid"
                                : ""
                            }`}
                            id={`jobTitle${index + 1}`}
                            value={contact.jobTitleId || ""}
                            onChange={(e) =>
                              handleContactChange(
                                index,
                                "jobTitleId",
                                e.target.value
                              )
                            }
                            disabled={isTextFieldDisable}
                          >
                            <option value="">Select Job Title</option>
                            {jobTitleList.map((jobTitle) => (
                              <option key={jobTitle.id} value={jobTitle.id}>
                                {jobTitle.value}
                              </option>
                            ))}
                          </select>
                          {validationErrors[`jobTitle${index}`] && (
                            <div className="invalid-feedback">
                              {validationErrors[`jobTitle${index}`]}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                  {!isTextFieldDisable && (
                    <div
                      className="d-flex justify-content-end"
                      style={{ marginTop: "-58px" }}
                    >
                      <button
                        className="branch-add-more-btn btn btn-secondary"
                        onClick={addContactEntry}
                        disabled={isSubmitting || contactEntries.length >= 5}
                      >
                        + Add More
                      </button>
                    </div>
                  )}

                  <div className="d-flex justify-content-center mt-3">
                    <button
                      className="branch-save-submit-btn btn btn-success"
                      onClick={handleSubmit}
                      disabled={isSubmitting || isTextFieldDisable}
                    >
                      {isSubmitting
                        ? "Submitting..."
                        : mapview
                        ? "Update"
                        : "Save & Submit"}
                    </button>
                    {/* <button 
                  className="branch-save-submit-btn btn btn-success"
                  onClick={handleCancelClick}
                  style={{marginLeft:'15px'}}
                
                >
                 Cancel
                </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Display loading indicator */}
          {loader && (
            <div className="loader-container">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}

          {showMapModal && (
            <Modal
              className="modal-position"
              size="lg"
              show={showMapModal}
              onHide={closeMapModal}
              aria-labelledby="example-modal-sizes-title-lg"
              right
            >
              <Modal.Header>
                <Modal.Title
                  id="example-modal-sizes-title-lg"
                  style={{ color: "#001b30", marginRight: "500px" }}
                >
                  {"Choose Location"}
                </Modal.Title>
                <XCircleblack
                  className="cursor-pointer"
                  onClick={closeMapModal}
                  width="1.5em"
                  height="1.5em"
                  style={{ color: "#001b30" }}
                />
              </Modal.Header>
              <Modal.Body>
                <div className="gis-mapcontainer">
                  {/* <LocationAutoComplete updateMapLocation={updateMapLocation} /> */}

                  <div key={mapKey} className="assetFormMap">
                    <MapWrapper
                      headerStyles={{ display: "none" }}
                      coordinates={coordinates}
                      chooseCoordinates={chooseCoordinates}
                      zoom={zoomLevel}
                      closeMapModal={closeMapModal}
                    />
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          )}
          <Modal
            show={showCancelModal}
            onHide={() => setShowCancelModal(false)}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirm </Modal.Title>
            </Modal.Header>
            <Modal.Body>Would you like to clear the input values?</Modal.Body>
            <Modal.Footer>
              <button
                className="btn"
                style={{
                  backgroundColor: "lightgray",
                  color: "#000",
                  marginRight: "10px",
                }}
                onClick={() => setShowCancelModal(false)}
              >
                No
              </button>
              <button
                className="btn"
                style={{
                  backgroundColor: "green",
                  color: "#fff",
                }}
                onClick={handleConfirmCancel}
              >
                Yes
              </button>
            </Modal.Footer>
          </Modal>
          <ToastContainer />
        </>
      )}
    </>
  );
};

export default CreateBranchForm;
